/**
 * Quantidade de material na tela.
 *
 * Dinheiro tem `formatBRL`; quantidade não tinha, e a mesma linha estava copiada em
 * `FichaTecnicaLinha` e `LinhaDeConsumo`. Com o estoque seria a terceira cópia.
 *
 * Quatro casas porque é o que o caso real exige: a ficha do Jun consome 0,0011 litro de resina.
 * Menos que isso arredondaria para zero e a tela mostraria "0" para um material que está sendo
 * gasto de verdade.
 */
export function formatarQuantidade(n: number): string {
  return n.toLocaleString("pt-BR", { maximumFractionDigits: 4 });
}

/** Com a unidade junto, quando ela é conhecida: "1,1 UN", "0,0176 L". */
export function formatarQuantidadeComUnidade(n: number, unidade: string | null | undefined): string {
  return unidade ? `${formatarQuantidade(n)} ${unidade}` : formatarQuantidade(n);
}

/** Texto do teclado brasileiro para número. Vírgula é o que se digita aqui. */
export const quantidadeParaNumero = (v: string) => Number((v || "0").replace(",", "."));

/** Número para o texto do campo — o inverso do de cima. */
export const numeroParaTexto = (n: number) => String(n).replace(".", ",");
